export const WARNING_BANNERS_TYPES = {
    HEALTH_WARNING: 'HEALTH_WARNING',
    WE_CARE: 'WE_CARE',
    HEALTH_WARNING_EXTENDED: 'HEALTH_WARNING_EXTENDED',
    HEALTH_WARNING_ALTERNATIVE_TOP: 'HEALTH_WARNING_ALTERNATIVE_TOP',
    HEALTH_WARNING_ALTERNATIVE_BOTTOM: 'HEALTH_WARNING_ALTERNATIVE_BOTTOM',
    HEALTH_WARNING_PRIMARY: 'HEALTH_WARNING_PRIMARY',
};
